const atualizarUnidadesAdm = (state, unidadesAdm) => {
    state.unidadesAdm = unidadesAdm;
}

const atualizarUnidadeAdm = (state, unidadeAdm) => {
    state.unidadeAdm = unidadeAdm;
}

export default {
    atualizarUnidadesAdm,
    atualizarUnidadeAdm
}